const state = {
  filtros: [],
  exibir_produtos: false,
}

const getters = {
  get_state(state) {
    return state;
  },
  get_filtros(state) {
    return state.filtros;
  },
  get_exibir_produtos(state) {
    return state.exibir_produtos;
  }
}

const mutations = {
  set_filtros(state, valor) {
    state.filtros = valor
  },
  set_exibir_produtos(state, valor) {
    state.exibir_produtos = valor
  }
}

const actions = {
  set_filtros: ({ commit }, valor) => {
    commit("set_filtros", valor)
  },
  set_exibir_produtos: ({ commit }, valor) => {
    commit("set_exibir_produtos", valor)
  }
}

export default { namespaced: true, state, mutations, getters, actions }
